/* configurateur tabs — v2 motifs jpg */
(function () {
  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel) { return Array.from(document.querySelectorAll(sel)); }

  function moveChildren(fromEl, toEl) {
    while (fromEl.firstChild) toEl.appendChild(fromEl.firstChild);
  }

  document.addEventListener("DOMContentLoaded", () => {
    const root = qs("#configurateur-tresse-root");
    if (!root) return;

    const mainStage = qs("#mainStage");
    const panel = qs("#mainPanel");
    const panelBody = qs("#panelBody");
    const tabBtns = qsa("#mainConfiguratorCard .tabBtn");
    const panelToggleBtn = qs("#panelToggleBtn");

    const cardBraidVisual = qs("#cardBraidVisual");
    const cardLitOptions = qs("#cardLitOptions");
    const cardBraidOptions = qs("#cardBraidOptions");
    const cardSummary = qs("#cardSummary");

    if (!mainStage || !panel || !panelBody || !tabBtns.length) return;
    if (!cardBraidVisual || !cardLitOptions || !cardBraidOptions || !cardSummary) {
      console.warn("[tabs] IDs manquants: vérifie cardBraidVisual/cardLitOptions/cardBraidOptions/cardSummary");
      return;
    }

    const viewBraid = document.createElement("div");
    viewBraid.className = "view view-braid";
    moveChildren(cardBraidVisual, viewBraid);

    const optWrap = document.createElement("div");
    optWrap.className = "opt opt-main";

    const optBraid = document.createElement("div");
    optBraid.className = "optSection opt-braid";
    moveChildren(cardBraidOptions, optBraid);

    const optLength = document.createElement("div");
    optLength.className = "optSection opt-length";
    moveChildren(cardLitOptions, optLength);

    const optSummary = document.createElement("div");
    optSummary.className = "optSection opt-summary";
    moveChildren(cardSummary, optSummary);

    optWrap.appendChild(optBraid);
    optWrap.appendChild(optLength);
    optWrap.appendChild(optSummary);

    let panelOpen = true;

    function syncToggleUi() {
      if (!panelToggleBtn) return;
      panelToggleBtn.setAttribute("aria-expanded", panelOpen ? "true" : "false");
      panelToggleBtn.setAttribute("aria-label", panelOpen ? "Réduire le panneau" : "Ouvrir le panneau");
    }

    function openPanel() {
      panel.classList.remove("is-closed");
      panel.setAttribute("aria-hidden", "false");
      panelOpen = true;
      syncToggleUi();
    }

    function closePanel() {
      panel.classList.add("is-closed");
      panel.setAttribute("aria-hidden", "true");
      panelOpen = false;
      syncToggleUi();
    }

    function togglePanel() {
      panelOpen ? closePanel() : openPanel();
    }

    mainStage.innerHTML = "";
    mainStage.appendChild(viewBraid);

    panelBody.innerHTML = "";
    panelBody.appendChild(optWrap);

    tabBtns.forEach(btn => {
      btn.addEventListener("click", () => togglePanel());
    });

    if (panelToggleBtn) {
      panelToggleBtn.addEventListener("click", () => togglePanel());
    }

    openPanel();
  });
})();
